import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { PersonEntrepreneurship } from '@interfaces';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<PersonEntrepreneurship, unknown>[] = [
		buildColumn(util, 'Id', row => row.id,),
		buildColumn(util, 'Id', row => row.programId, { header: 'Program ID' }),
		buildColumn(util, 'Text', row => row.trimesterName, { header: 'Trimester' }),
		buildColumn(util, 'Text', row => row.programType, { header: 'Program Type' }),
		buildColumn(util, 'Text', row => row.role, { header: 'Role' }),
		buildColumn(util, 'Text', row => row.status, { header: 'Status' }),
		buildColumn(util, 'Text', row => row.programName, { header: 'Program Name' }),
		buildColumn(util, 'Text', row => row.ventureName, { header: 'Venture Name' }),
		buildColumn(util, 'Text', row => row.awardedAmount ? `Awarded ${row.awardedAmount.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 })}` : '', { header: 'Details' }),
	];

	return columns;

}